import request from '../utils/request.util'

export default {
  login (params) {
    return request.post('/login', params)
  },
  getMe () {
    return request.post('/me')
  }
}
